import * as React from "react";
import moment from "moment";
import "moment/locale/es";

var UsersList = function UsersList(props) {
  var users = props.users,
      token = props.token,
      setUsers = props.setUsers;

  var handleDelete = function handleDelete(user) {
    var _document$querySelect;

    if (!window.confirm("¿Eliminar este agente?")) return;
    var csrfToken = ((_document$querySelect = document.querySelector('meta[name="csrf-token"]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.getAttribute("content")) || token;
    fetch("/admin/administrators/".concat(user.id), {
      method: "DELETE",
      headers: {
        "X-CSRF-Token": csrfToken,
        Accept: "text/html"
      },
      credentials: "same-origin"
    }).then(function (res) {
      if (res.redirected) window.location.href = res.url;else if (res.ok) window.location.reload();else window.alert("No se pudo eliminar.");
    })["catch"](function () {
      return window.alert("Error al eliminar.");
    });
  };

  var formatDate = function formatDate(date) {
    if (!date) return "-";
    return moment(date).format("DD/MM/YYYY");
  };

  var getAge = function getAge(birthdate) {
    if (!birthdate) return "-";
    var age = moment().diff(moment(birthdate), "years");
    return "".concat(age, " a\xF1os");
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-header"
  }, /*#__PURE__*/React.createElement("h4", null, /*#__PURE__*/React.createElement("b", null, "Lista de Ejecutivos"))), /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "table-responsive"
  }, /*#__PURE__*/React.createElement("table", {
    className: "table table-striped table-hover"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Fecha Creaci\xF3n"), /*#__PURE__*/React.createElement("th", null, "Nombre Completo"), /*#__PURE__*/React.createElement("th", null, "RUT"), /*#__PURE__*/React.createElement("th", null, "Cargo"), /*#__PURE__*/React.createElement("th", null, "Inicio Contrato"), /*#__PURE__*/React.createElement("th", null, "Fin Contrato"), /*#__PURE__*/React.createElement("th", null, "\xDAltima Actualizaci\xF3n"), /*#__PURE__*/React.createElement("th", null, "Fecha Nacimiento"), /*#__PURE__*/React.createElement("th", null, "Edad"), /*#__PURE__*/React.createElement("th", null, "Tel\xE9fono"), /*#__PURE__*/React.createElement("th", null, "Email"), /*#__PURE__*/React.createElement("th", null, "Acciones"))), /*#__PURE__*/React.createElement("tbody", null, users.map(function (user) {
    return /*#__PURE__*/React.createElement("tr", {
      key: user.id
    }, /*#__PURE__*/React.createElement("td", null, formatDate(user.created_at)), /*#__PURE__*/React.createElement("td", null, user.full_name || user.calculated_full_name || "-"), /*#__PURE__*/React.createElement("td", null, user.rut || user.calculated_rut || "-"), /*#__PURE__*/React.createElement("td", null, user.position || "-"), /*#__PURE__*/React.createElement("td", null, formatDate(user.contract_start_date)), /*#__PURE__*/React.createElement("td", null, formatDate(user.contract_end_date)), /*#__PURE__*/React.createElement("td", null, formatDate(user.updated_at)), /*#__PURE__*/React.createElement("td", null, formatDate(user.birthdate)), /*#__PURE__*/React.createElement("td", null, user.birthdate ? getAge(user.birthdate) : "-"), /*#__PURE__*/React.createElement("td", null, user.phone || "-"), /*#__PURE__*/React.createElement("td", null, user.email), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("a", {
      href: "/admin/administrators/".concat(user.id),
      className: "btn btn-sm btn-info",
      style: {
        marginRight: "5px"
      }
    }, "Ver"), /*#__PURE__*/React.createElement("a", {
      href: "/admin/administrators/".concat(user.id, "/edit"),
      className: "btn btn-sm btn-primary",
      style: {
        marginRight: "5px"
      }
    }, "Editar"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "btn btn-sm btn-danger",
      onClick: function onClick() {
        return handleDelete(user);
      }
    }, "Eliminar")));
  }))))));
};

export default UsersList;